import { createSchema } from 'morphism';

import { PRODUCT_LIST_PAGINATION_LIMIT } from '@hero/constants';

const productListSchema = createSchema(
  {
    filters: {
      productCodes: source => source?.filters?.productCodes?.join(','),
      merchantProductIds: source => source?.filters?.merchantProductIds?.join(','),
      skus: source => source?.filters?.skus?.join(','),
      parentProductCode: 'filters.parentProductCode',
      searchTerm: 'filters.searchTerm',
      isBackup: 'filters.isBackup',
      maxPrice: 'filters.maxPrice',
      minPrice: 'filters.minPrice',
      tags: 'filters.tags',
      organizations: 'filters.organizations',
      type: 'filters.type',
      categoryIds: source => source?.filters?.categoryIds?.join(','),
      collectionIds: source => source?.filters?.collectionIds?.join(','),
      brandIds: source => source?.filters?.brandIds?.join(','),
      charityOnly: 'filters.charityOnly'
    },
    pagination: {
      limit: source => source?.pagination?.limit ?? PRODUCT_LIST_PAGINATION_LIMIT,
      page: source => source?.pagination?.page ?? 1,
      sort: 'pagination.sort',
      cursor: 'pagination.cursor',
      type: 'pagination.type'
    },
    options: {
      pagination: 'options.pagination'
    }
  },
  { undefinedValues: { strip: true } }
);

export default {
  productList: productListSchema
};
